/*
 *   File : secondary.js
 *   Author : https://evoqins.com
 *   Description : Secondary button component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';

const SecondaryButton = (props) => {
    return (
        <button className={`${props.className} ${props.loader ? "pe-none" : ""} ${props.paddingBlock ? props.paddingBlock : 'padding-12px-tb padding-20px-lr'} m-0 border-radius-8  bg-transparent e-font-14 e-primary-font  e-font-weight-600 line-height-16px  ${props.disabled ? 'opacity-50 border-1 e-text-gray' : 'e-text-blue-violet e-border-1px-blue-violet'} `}
            data-bs-toggle={props.toggle}
            data-bs-target={props.target}
            data-bs-cancel={props.cancel}
            data-bs-dismiss={props.dismiss}
            disabled={props.disabled}
            id={props.id}
            ref={props.ref}
            onKeyDown={props.onKeyDown}
            onClick={(e) => props.onClick(e)}>
            {props.loader ?
                <div className="loader">
                    <div className="ball"></div>
                    <div className="ball"></div>
                    <div className="ball"></div>
                    <div className="ball"></div>
                </div>
                :
                <>
                    {props.name}
                </>
            }
        </button>
    )
}

SecondaryButton.defaultProps = {
    onKeyDown: () => { },
    onClick: () => { },
    className: null,
    id: null,
    name: null
};

export default memo(SecondaryButton);